import React, { Suspense, useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import { isMobile } from "react-device-detect";
import { Helmet } from "react-helmet";

import { Link } from "react-router-dom/cjs/react-router-dom";
// ✅ Importaciones corregidas para Swiper v6
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import * as serachActions from "../../store/search/actions";
import "../LandingPage/landing-home.css";
// ✅ CSS corregido para Swiper v6
import "swiper/css";
import "swiper/css/pagination";

import marDelPlataTitle from "../../assets/static/Promos/mar-del-plata-title.webp";
import iguazuTitle from "../../assets/static/Promos/iguazu-title.webp";
import BariloTitle from "../../assets/static/Promos/barilo-title.webp";
import aloharOrangeTitle from "../../assets/static/landing-host/alohar-orange.png";
import arrow from "../../assets/static/Icons/arrowShort.png";
import heroAlohar from "../../assets/static/background-abril/hero-alohar.png";
import heroPatagonia from "../../assets/static/background-abril/hero-patagonia.jpg.jpeg";
import heroNoche from "../../assets/static/background-abril/hero-noche.jpg.jpeg";
import heroWorking from "../../assets/static/working.jpg";
import Footer from "../Footer/Footer";
import { HertzModal } from "../Modals/hertzModal";
import MainInputSearchNew from "../MainSearch/MainInputSearchNew";
import Navbar from "../Navbar/Navbar";
import SectionCard from "../AloharForm/components/SectionCard";
import SelectCity from "../MainSearch/SelectCity";
import SwiperBanks from "./landing-components/SwiperBanks";
import WhatsAppButton from "../Buttons/WhatsAppButton";
import moment from "moment";
import ImageLazyLoad from "../ui/image-lazyLoad";
import { BASE_URL } from "../../Helpers";
import AxiosAuth from "../../services/requestApi";
import PromotionsDesktop from "./landing-components/PromotionsDesktop";
import WeDontWannaGetSued from "./WeDontWannaGetSued";
import HousingPromotions from "./housing-promotions";
import axios from "axios";
import BannerHertz from "./landing-components/BannerHertz";
import BannerApp from "./landing-components/BannerApp";
import BannerViajaMas from "./landing-components/BannerViajaMas";
import BannerCampana from "./landing-components/BannerCampana";
import HomeNavbar from "./HomeNavbar";

import tradLanding from "./tradLandingPage.json";
import useCurrentLanguage from "../../services/currentlenguaje";

const heroImages = [heroAlohar, heroPatagonia, heroNoche, heroWorking];

const featuredDestinations = [
  {
    title: "Mar del Plata",
    description:
      "Escapadas frente al mar, departamentos céntricos y opciones para vacaciones familiares durante todo el año.",
    to: "/mar-del-plata/search?city=1&checkin=24/03/26&checkout=29/03/26&childs=0&adults=2&cityName=Mar%20del%20Plata",
    guide: "/destinos/mar-del-plata",
  },
  {
    title: "Bariloche",
    description:
      "Cabañas, departamentos y alojamientos para combinar naturaleza, nieve, lagos y viajes en pareja o grupo.",
    to: "/bariloche/search?city=56&checkin=24/03/26&checkout=29/03/26&childs=0&adults=2&cityName=bariloche",
    guide: "/destinos/bariloche",
  },
  {
    title: "Iguazú",
    description:
      "Alojamientos para descubrir las cataratas, hacer una pausa corta y planear un viaje distinto por Argentina.",
    to: "/iguazu/search?city=69&checkin=24/03/26&checkout=29/03/26&childs=0&adults=2&cityName=iguazu",
    guide: "/destinos/iguazu",
  },
];

const howItWorksSteps = [
  {
    title: "Buscá tu destino",
    description:
      "Elegí ciudad, fechas y cantidad de huéspedes para explorar alojamientos temporarios en destinos argentinos con información clara y rutas públicas accesibles.",
  },
  {
    title: "Compará y elegí",
    description:
      "Revisá fotos, ubicación, servicios, capacidad y reglas del alojamiento para tomar una decisión informada antes de reservar.",
  },
  {
    title: "Reservá con simpleza",
    description:
      "Completá tu reserva desde la plataforma y seguí el proceso según el tipo de alojamiento y medio de pago disponible.",
  },
];

const whyBookItems = [
  {
    title: "Destinos locales y escapadas reales",
    description:
      "Alohar está pensado para encontrar alojamientos en Argentina, desde ciudades costeras hasta destinos de montaña y viajes cortos durante el año.",
  },
  {
    title: "Información útil antes de reservar",
    description:
      "La experiencia se apoya en detalles visibles de la propiedad, capacidad, condiciones y contexto para reducir sorpresas al momento de elegir.",
  },
  {
    title: "Exploración flexible",
    description:
      "Podés usar la home para inspirarte, comparar ciudades y empezar a planear un viaje sin necesidad de llegar con una decisión cerrada.",
  },
  {
    title: "Plataforma orientada al viajero argentino",
    description:
      "El contenido, la navegación y la propuesta comercial están centrados en quienes buscan viajar dentro del país de forma práctica.",
  },
];

const homeFaqs = [
  {
    question: "¿Qué tipo de alojamientos puedo encontrar en Alohar?",
    answer:
      "Podés explorar departamentos, casas, cabañas y otras opciones de estadía temporaria en distintos destinos de Argentina, según disponibilidad.",
  },
  {
    question: "¿Puedo usar Alohar para planear escapadas cortas?",
    answer:
      "Sí. La plataforma sirve tanto para vacaciones más largas como para fines de semana, viajes urbanos, trabajo remoto o pausas breves durante el año.",
  },
  {
    question: "¿La home ya me permite descubrir destinos?",
    answer:
      "Sí. Además del buscador, la portada muestra ciudades destacadas, información útil y enlaces internos para empezar a comparar opciones rápidamente.",
  },
  {
    question: "¿Dónde encuentro ayuda si tengo dudas antes de reservar?",
    answer:
      "Podés consultar el Centro de Ayuda con preguntas frecuentes sobre reservas, cancelaciones, pagos y funcionamiento general de la plataforma.",
  },
  {
    question: "¿Alohar sirve solo para viajes de temporada alta?",
    answer:
      "No. También es útil para escapadas fuera de temporada, viajes laborales, eventos, feriados y estadías cortas en distintos momentos del año.",
  },
];

const promotionsFallbackLinks = [
  {
    label: "Explorar Mar del Plata",
    to: "/mar-del-plata/search?city=1&checkin=24/03/26&checkout=29/03/26&childs=0&adults=2&cityName=Mar%20del%20Plata",
  },
  {
    label: "Ver Centro de Ayuda",
    to: "/ayuda",
  },
];

const LandingHome = (props) => {
  const { handleFilterLang } = useCurrentLanguage();
  const heroTitle = handleFilterLang(tradLanding).vosViaja;
  const { setCity, searchReducer } = props;
  const isPrerendering =
    typeof navigator !== "undefined" && navigator.userAgent === "ReactSnap";

  const [number, setNumber] = useState([]);
  const [promotionsUnavailable, setPromotionsUnavailable] = useState(false);
  const [typedHeroText, setTypedHeroText] = useState(
    isPrerendering ? heroTitle : ""
  );
  const [showTypingCursor, setShowTypingCursor] = useState(!isPrerendering);
  const [showTopNavbar, setShowTopNavbar] = useState(true);
  const [heroImageIndex, setHeroImageIndex] = useState(0);

  const codeDiscount = async () => {
    const url = `${BASE_URL}/hertz`;
    try {
      const response = await AxiosAuth.get(url);
      setNumber([response.data]);
    } catch (error) {
      console.log(error);
    }
    setOpenModal(true);
  };
  const [openModal, setOpenModal] = useState(false);
  const first = useRef(null);

  const checkin = moment(Date.now()).utc(true).format("DD/MM/YY");
  const checkout = moment().add(5, "days").format("DD/MM/YY");
  
  useEffect(() => {
    setCity({ city: null, cityName: null });
    const url = `${BASE_URL}/location/promotions`;
    axios
      .get(url)
      .then(() => {
        setPromotionsUnavailable(false);
      })
      .catch(() => {
        setPromotionsUnavailable(true);
      });
  }, [setCity]);

  useEffect(() => {
    if (isPrerendering) {
      setTypedHeroText(heroTitle);
      setShowTypingCursor(false);
      return;
    }

    setTypedHeroText("");

    let currentIndex = 0;
    const typingInterval = setInterval(() => {
      currentIndex += 1;
      setTypedHeroText(heroTitle.slice(0, currentIndex));

      if (currentIndex >= heroTitle.length) {
        clearInterval(typingInterval);
      }
    }, 75);

    return () => clearInterval(typingInterval);
  }, [heroTitle, isPrerendering]);

  useEffect(() => {
    if (isPrerendering) {
      return undefined;
    }

    const cursorInterval = setInterval(() => {
      setShowTypingCursor((previousValue) => !previousValue);
    }, 500);

    return () => clearInterval(cursorInterval);
  }, [isPrerendering]);

  useEffect(() => {
    if (isPrerendering) {
      return undefined;
    }

    const heroImageInterval = setInterval(() => {
      setHeroImageIndex(
        (previousIndex) => (previousIndex + 1) % heroImages.length
      );
    }, 5000);

    return () => clearInterval(heroImageInterval);
  }, [isPrerendering]);

  useEffect(() => {
    const handleScrollNavbar = () => {
      setShowTopNavbar(window.scrollY < 90);
    };

    handleScrollNavbar();
    window.addEventListener("scroll", handleScrollNavbar, { passive: true });

    return () => {
      window.removeEventListener("scroll", handleScrollNavbar);
    };
  }, []);

  return (
    <>
      <Helmet>
        <title>Alohar | Alojate en pesos, fácil y seguro</title>
        <meta
          name="description"
          content="Encontrá alojamientos temporarios en Argentina, compará destinos, descubrí escapadas y reservá tu próxima estadía en Alohar."
        />
        <link rel="canonical" href="https://alohar.me/" />
      </Helmet>
      <div
        id="0"
        className="flex flex-col justify-between min-h-screen "
        ref={first}
      >
        <div
          style={{
            opacity: showTopNavbar ? 1 : 0,
            pointerEvents: showTopNavbar ? "auto" : "none",
            transition: "opacity 220ms ease",
          }}
        >
          <Navbar
            isLanding={true}
            logo="orange"
            showMobile={true}
            icon={true}
          />
        </div>

        <HomeNavbar threshold={100} />

        <div className="flex  flex-col w-full mx-auto sm:w-11/12 sm:gap-[4vw] sm:pb-14 sm:mt-[-125px]  relative swiperHome">
            <section
              id="estatic-home"
              className={`flex sm:rounded-b-[10vw] overflow-hidden relative flex-col sm:justify-center items-center h-screen sm:min-h-screen sm:h-screen py-[7%]`}
            >
              {heroImages.map((image, index) => (
                <div
                  key={image}
                  className="absolute inset-0 z-0 bg-cover bg-top transition-opacity duration-1000 ease-in-out"
                  style={{
                    backgroundImage: `url(${image})`,
                    backgroundPosition: isMobile
                      ? "center top"
                      : "center center",
                    opacity: index === heroImageIndex ? 1 : 0,
                  }}
                />
              ))}

              {/* Contenedor para el contenido con z-index mayor */}
              <div className="absolute inset-0 z-10 flex flex-col sm:justify-center items-center py-[7%]">
                {isMobile && (
                  <h1 className="block sm:hidden absolute left-1/2 -translate-x-1/2 bottom-[30vw] z-20 w-[82%] text-center text-white font-castaBold text-[7vw] leading-[1.05] text-balance">
                    {heroTitle}
                  </h1>
                )}

                {isMobile && searchReducer.city && (
                  <div className="absolute sm:hidden flex top-0 left-0 z-40 w-full h-screen min-h-[700px] bg-white pt-[100px]">
                    <MainInputSearchNew />
                  </div>
                )}
                
                {!isMobile && (
                  <div className="hidden w-11/12 items-center justify-center sm:flex sm:mt-[15vw] z-40 max-w-[1200px]">
                    <MainInputSearchNew />
                  </div>
                )}

                {isMobile && (
                  <div className="z-30 flex flex-col items-center justify-center w-11/12 h-auto px-1 py-8 mt-[30vh] bg-white sm:hidden rounded-70 relative">
                    <h2 className="w-[70%] mx-auto text-[3vw] sm:text-lg font-semibold mb-4">
                      {handleFilterLang(tradLanding).proximoDestino} <br />
                    </h2>
                    <div className="homeInputCity w-full px-4">
                      <SelectCity
                        selectedCity={props.searchReducer.city}
                        placeholder={handleFilterLang(tradLanding).dondeVamos}
                      />
                    </div>
                  </div>
                )}

                <h1 className="sm:mt-9 hidden sm:block ms:text-[3vw] text-[3.5vw] text-center text-white font-castaBold z-20 min-h-[1.4em]">
                  {typedHeroText}
                  <span style={{ opacity: showTypingCursor ? 1 : 0 }}>|</span>
                </h1>
              </div>
            </section>

            {!promotionsUnavailable && <HousingPromotions />}

            <BannerCampana />

            <BannerHertz codeDiscount={codeDiscount} />

            {!promotionsUnavailable ? (
              <PromotionsDesktop />
            ) : (
              <section className="w-full px-4 sm:px-0">
                <div className="mx-auto grid w-full max-w-[1180px] gap-5 rounded-[32px] bg-white px-6 py-8 shadow-[0_18px_60px_rgba(15,23,42,0.08)] sm:px-10 sm:py-10 lg:grid-cols-[1.15fr_0.85fr]">
                  <div>
                    <p className="mb-3 text-[12px] font-semibold uppercase tracking-[0.24em] text-[#FF4E00]">
                      Promociones temporales
                    </p>
                    <p className="text-[24px] leading-[1.15] text-[#172033] sm:text-[32px] font-castaBold">
                      La portada sigue disponible aunque las promociones destacadas no estén cargadas en este momento
                    </p>
                    <p className="mt-4 text-[15px] leading-7 text-slate-600 sm:text-[16px]">
                      Podés usar el buscador, revisar destinos sugeridos y avanzar desde la home con contenido completo mientras se restablece el módulo promocional dinámico.
                    </p>
                  </div>
                  <div className="flex flex-col justify-center gap-3">
                    {promotionsFallbackLinks.map((item) => (
                      <Link
                        key={item.to}
                        to={item.to}
                        className="inline-flex items-center justify-between rounded-[20px] border border-slate-200 px-5 py-4 text-[15px] font-semibold text-[#172033] transition-colors hover:border-[#FF4E00] hover:text-[#FF4E00]"
                      >
                        {item.label}
                      </Link>
                    ))}
                  </div>
                </div>
              </section>
            )}

            <section className="w-full px-4 sm:px-0">
              <div className="mx-auto grid w-full max-w-[1180px] gap-6 rounded-[32px] bg-white px-6 py-8 shadow-[0_18px_60px_rgba(15,23,42,0.08)] sm:px-10 sm:py-10">
                <div className="max-w-[760px]">
                  <p className="mb-3 text-[12px] font-semibold uppercase tracking-[0.24em] text-[#FF4E00]">
                    Cómo funciona Alohar
                  </p>
                  <h2 className="text-[28px] leading-[1.1] text-[#172033] sm:text-[38px] font-castaBold">
                    Una forma simple de descubrir alojamientos y planear viajes por Argentina
                  </h2>
                  <p className="mt-4 text-[15px] leading-7 text-slate-600 sm:text-[16px]">
                    Alohar combina búsqueda, exploración de destinos y contenido útil para que la decisión de viaje no dependa solo de una grilla de cards. La idea es que puedas entender mejor cada destino, comparar alojamientos y reservar con una visión más clara del tipo de estadía que necesitás.
                  </p>
                </div>
                <div className="grid gap-4 md:grid-cols-3">
                  {howItWorksSteps.map((step, index) => (
                    <article
                      key={step.title}
                      className="rounded-[24px] border border-slate-100 bg-[#fff8f3] p-5"
                    >
                      <div className="mb-4 grid h-10 w-10 place-items-center rounded-full bg-[#172033] text-sm font-bold text-white">
                        0{index + 1}
                      </div>
                      <h3 className="text-[18px] font-semibold text-[#172033]">
                        {step.title}
                      </h3>
                      <p className="mt-3 text-[15px] leading-7 text-slate-600">
                        {step.description}
                      </p>
                    </article>
                  ))}
                </div>
              </div>
            </section>

            <section className="w-full px-4 sm:px-0">
              <div className="mx-auto grid w-full max-w-[1180px] gap-8 rounded-[32px] bg-[#172033] px-6 py-8 text-white sm:px-10 sm:py-10 lg:grid-cols-[1.05fr_0.95fr]">
                <div>
                  <p className="mb-3 text-[12px] font-semibold uppercase tracking-[0.24em] text-[#96F9FF]">
                    Por qué reservar con Alohar
                  </p>
                  <h2 className="text-[28px] leading-[1.1] sm:text-[38px] font-castaBold">
                    Más que una búsqueda rápida: contexto, inspiración y opciones para viajar mejor
                  </h2>
                  <p className="mt-4 text-[15px] leading-7 text-slate-200 sm:text-[16px]">
                    Cuando alguien busca un alojamiento temporario, no siempre tiene definido el lugar exacto, el tipo de estadía o incluso el ritmo del viaje. Por eso la home también funciona como una puerta de entrada editorial: muestra destinos, explica la propuesta y ayuda a entender qué ofrece Alohar para viajeros que recorren Argentina.
                  </p>
                </div>
                <div className="grid gap-4 sm:grid-cols-2">
                  {whyBookItems.map((item) => (
                    <article key={item.title} className="rounded-[24px] border border-white/10 bg-white/5 p-5 backdrop-blur-sm">
                      <h3 className="text-[18px] font-semibold text-white">{item.title}</h3>
                      <p className="mt-3 text-[14px] leading-7 text-slate-200">
                        {item.description}
                      </p>
                    </article>
                  ))}
                </div>
              </div>
            </section>

            <section className="w-full px-4 sm:px-0">
              <div className="mx-auto w-full max-w-[1180px] rounded-[32px] bg-white px-6 py-8 shadow-[0_18px_60px_rgba(15,23,42,0.08)] sm:px-10 sm:py-10">
                <div className="max-w-[760px]">
                  <p className="mb-3 text-[12px] font-semibold uppercase tracking-[0.24em] text-[#FF4E00]">
                    Destinos destacados
                  </p>
                  <h2 className="text-[28px] leading-[1.1] text-[#172033] sm:text-[38px] font-castaBold">
                    Ideas para empezar a explorar ciudades y escapadas dentro de Argentina
                  </h2>
                  <p className="mt-4 text-[15px] leading-7 text-slate-600 sm:text-[16px]">
                    Si todavía no decidiste tu próximo viaje, estos destinos son un buen punto de partida para comparar estadías, inspirarte y entrar directo a resultados públicos de búsqueda.
                  </p>
                </div>
                <div className="mt-8 grid gap-4 md:grid-cols-3">
                  {featuredDestinations.map((destination) => (
                    <article key={destination.title} className="rounded-[24px] border border-slate-200 bg-slate-50 p-5">
                      <h3 className="text-[20px] font-semibold text-[#172033]">
                        {destination.title}
                      </h3>
                      <p className="mt-3 text-[15px] leading-7 text-slate-600">
                        {destination.description}
                      </p>
                      <Link
                        to={destination.to}
                        className="mt-5 inline-flex items-center text-[14px] font-semibold text-[#FF4E00]"
                      >
                        Ver alojamientos en {destination.title}
                      </Link>
                      <Link
                        to={destination.guide}
                        className="mt-2 inline-flex items-center text-[13px] text-slate-500 hover:text-[#FF4E00]"
                      >
                        Guía del destino →
                      </Link>
                    </article>
                  ))}
                </div>
              </div>
            </section>

            <section className="w-full px-4 sm:px-0">
              <div className="mx-auto grid w-full max-w-[1180px] gap-6 rounded-[32px] bg-[#f5f1ea] px-6 py-8 sm:px-10 sm:py-10 lg:grid-cols-[0.9fr_1.1fr]">
                <div>
                  <p className="mb-3 text-[12px] font-semibold uppercase tracking-[0.24em] text-[#FF4E00]">
                    Valor para viajeros
                  </p>
                  <h2 className="text-[28px] leading-[1.1] text-[#172033] sm:text-[38px] font-castaBold">
                    Qué aporta Alohar a quienes quieren viajar por Argentina
                  </h2>
                </div>
                <div className="space-y-4 text-[15px] leading-7 text-slate-700 sm:text-[16px]">
                  <p>
                    Alohar busca ordenar la experiencia de búsqueda para personas que quieren encontrar alojamientos temporarios en Argentina sin depender únicamente de filtros rápidos o publicidad vacía. La plataforma intenta mostrar opciones de estadía, contexto del destino y caminos claros para avanzar hacia la reserva.
                  </p>
                  <p>
                    En lugar de funcionar solo como un catálogo visual, la home ayuda a comparar tipos de viaje: escapadas urbanas, vacaciones familiares, pausas de pocos días o recorridos por distintas ciudades. Eso mejora la utilidad editorial del sitio y da más información visible al usuario antes de entrar al detalle de una propiedad.
                  </p>
                  <p>
                    Si querés profundizar antes de reservar, también podés consultar el <Link to="/ayuda" className="font-semibold text-[#FF4E00]">Centro de Ayuda</Link> o revisar los <Link to="/terminos" className="font-semibold text-[#FF4E00]">Términos y Condiciones</Link> para entender mejor cómo funciona la plataforma.
                  </p>
                </div>
              </div>
            </section>

            <section className="w-full px-4 sm:px-0">
              <div className="mx-auto w-full max-w-[1180px] rounded-[32px] bg-white px-6 py-8 shadow-[0_18px_60px_rgba(15,23,42,0.08)] sm:px-10 sm:py-10">
                <div className="max-w-[760px]">
                  <p className="mb-3 text-[12px] font-semibold uppercase tracking-[0.24em] text-[#FF4E00]">
                    Preguntas frecuentes
                  </p>
                  <h2 className="text-[28px] leading-[1.1] text-[#172033] sm:text-[38px] font-castaBold">
                    Dudas comunes antes de elegir una estadía en Alohar
                  </h2>
                </div>
                <div className="mt-8 grid gap-4">
                  {homeFaqs.map((faq) => (
                    <details key={faq.question} className="rounded-[22px] border border-slate-200 bg-slate-50 px-5 py-4">
                      <summary className="cursor-pointer list-none text-[17px] font-semibold text-[#172033]">
                        {faq.question}
                      </summary>
                      <p className="mt-3 text-[15px] leading-7 text-slate-600">
                        {faq.answer}
                      </p>
                    </details>
                  ))}
                </div>
              </div>
            </section>

            <section className="w-full px-4 sm:px-0">
              <div className="mx-auto w-full max-w-[1180px] rounded-[32px] bg-[#172033] px-6 py-8 text-white sm:px-10 sm:py-10">
                <p className="mb-3 text-[12px] font-semibold uppercase tracking-[0.24em] text-[#96F9FF]">
                  Guía editorial
                </p>
                <h2 className="text-[28px] leading-[1.1] sm:text-[38px] font-castaBold">
                  Encontrar alojamientos temporarios en Argentina también puede empezar con una buena lectura del viaje
                </h2>
                <div className="mt-6 grid gap-5 text-[15px] leading-7 text-slate-200 sm:text-[16px] lg:grid-cols-2">
                  <p>
                    Viajar por Argentina implica escenarios muy distintos: escapadas de playa, rutas gastronómicas, ciudades de montaña, feriados largos o estadías cortas por trabajo. En todos esos casos, encontrar un alojamiento adecuado no depende solo del precio. También importan la ubicación, la capacidad, el tipo de propiedad, el ritmo del destino y la claridad con la que se presenta la información.
                  </p>
                  <p>
                    Por eso Alohar busca que la portada no sea únicamente un buscador. La home suma texto útil, destinos destacados y secciones que ayudan a interpretar el uso del sitio antes de pasar al detalle. Para quienes están empezando a organizar sus vacaciones o simplemente quieren comparar opciones de alojamiento temporario dentro del país, ese contexto hace que la navegación sea más comprensible, más humana y más valiosa desde el primer ingreso.
                  </p>
                </div>
              </div>
            </section>

            {isMobile && (
              <Suspense fallback={<></>}>
                <Swiper
                  modules={[Autoplay, Pagination]}
                  spaceBetween={0}
                  slidesPerView={1}
                  pagination={{ clickable: true }}
                  autoplay={{
                    delay: 3000,
                    disableOnInteraction: false,
                  }}
                  className="relative block w-full h-screen"
                >
                  <SwiperSlide>
                    <div className="flex flex-col h-full swiperHome">
                      <div
                        className={`relative bg-top bg-cover bg-bariloche  flex justify-center items-center h-[65%] row-span-2`}
                      >
                        <ImageLazyLoad
                          alt={"Bariloche"}
                          src={BariloTitle}
                          className={`bg-center left-[20%]  top-1/2  absolute
                      -translate-y-1/2   bg-no-repeat w-[200px]  `}
                        />
                      </div>
                      <div className="flex items-center pl-[20%] bg-primaryHome h-[35%] text-white ">
                        <Link
                          rel="noopener noreferrer"
                          to={`bariloche/search?city=56&checkin=${checkin}&checkout=${checkout}&childs=0&adults=1&cityName=bariloche`}
                          className="flex flex-col gap-4  text-white text-[6vw] hover:text-white RobotoBold  leading-[130%] "
                        >
                          {handleFilterLang(tradLanding).alohamientos} <br />
                          {`desde AR$ ${Intl.NumberFormat("de-AR", {
                            minimumFractionDigits: 0,
                            maximumFractionDigits: 2,
                          }).format(parseFloat(45000).toFixed(2))}`}
                          <br />
                          {handleFilterLang(tradLanding).porDia}
                          <img src={arrow} className="w-[7vw]" alt="Arrow" />
                        </Link>
                      </div>
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div className="flex flex-col h-full ">
                      <div
                        className={`relative bg-top bg-cover bg-iguazu  flex justify-center items-center h-[65%] row-span-2`}
                      >
                        <ImageLazyLoad
                          alt={"Iguzu"}
                          src={iguazuTitle}
                          className={`bg-center left-[20%]  top-1/2  absolute
                      -translate-y-1/2   bg-no-repeat w-[200px]  `}
                        />
                      </div>
                      <div className="flex items-center pl-[20%] bg-primaryHome h-[35%] text-white ">
                        <Link
                          rel="noopener noreferrer"
                          to={`iguzu/search?city=69&checkin=${checkin}&checkout=${checkout}&childs=0&adults=1&cityName=iguzu`}
                          className="flex flex-col gap-4  text-white text-[6vw] hover:text-white font-RobotoBold  leading-[130%] "
                        >
                          {handleFilterLang(tradLanding).alohamientos} <br />
                          {`desde AR$ ${Intl.NumberFormat("de-AR", {
                            minimumFractionDigits: 0,
                            maximumFractionDigits: 2,
                          }).format(parseFloat(25000).toFixed(2))}`}
                          <br />
                          {handleFilterLang(tradLanding).porDia}
                          <img src={arrow} className="w-[7vw]" alt="Arrow" />
                        </Link>
                      </div>
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div className="flex flex-col h-full ">
                      <div
                        className={`relative bg-top bg-cover bg-marDelPlata  flex justify-center items-center h-[65%] row-span-2`}
                      >
                        <div className="relative w-full ">
                          <ImageLazyLoad
                            alt={"Mar del plata"}
                            src={marDelPlataTitle}
                            className={`bg-center left-[20%]  top-1/2  absolute
                      -translate-y-1/2   bg-no-repeat w-[200px]  `}
                          />
                        </div>
                      </div>
                      <div className="flex items-center pl-[20%] bg-primaryHome h-[35%] text-white ">
                        <Link
                          rel="noopener noreferrer"
                          to={`mar del plata/search?city=1&checkin=${checkin}&checkout=${checkout}&childs=0&adults=1&cityName=mar del plata`}
                          className="flex flex-col gap-4  text-white text-[6vw] hover:text-white font-RobotoBold  leading-[130%] "
                        >
                          {handleFilterLang(tradLanding).alohamientos} <br />
                          {`desde AR$ ${Intl.NumberFormat("de-AR", {
                            minimumFractionDigits: 0,
                            maximumFractionDigits: 2,
                          }).format(parseFloat(12000).toFixed(2))}`}
                          <br />
                          {handleFilterLang(tradLanding).porDia}
                          <img src={arrow} className="w-[7vw]" alt="Arrow" />
                        </Link>
                      </div>
                    </div>
                  </SwiperSlide>
                </Swiper>
              </Suspense>
            )}

            {/* Sección "Ser Alohador" - visible en desktop y mobile */}
            <Suspense fallback={<></>}>
              <SectionCard
                link={"/alohar"}
                alt={"Alohar"}
                title={aloharOrangeTitle}
                backgroundColor={"bg-dark50"}
                backgroundImg={"bg-girl"}
                styleBackground={{
                  backgroundPositionY: "85%",
                  backgroundPositionX: "100%",
                  backgroundSize: "117%",
                }}
                secondTitle={
                  <>
                    {handleFilterLang(tradLanding).alohaGente} <br />
                    {handleFilterLang(tradLanding).enTuCasa} <br />{" "}
                    {handleFilterLang(tradLanding).yPesos}
                    <br /> {handleFilterLang(tradLanding).enTuCuenta}
                  </>
                }
              >
                {handleFilterLang(tradLanding).serAlohador}
                <br />
                {handleFilterLang(tradLanding).esMuySencillo} <br />
                {handleFilterLang(tradLanding).enterateComo}
              </SectionCard>
            </Suspense>

          </div>
          <WeDontWannaGetSued />

          <Footer />
          <HertzModal
            setOpenModal={setOpenModal}
            openModal={openModal}
            number={number}
          />
          <WhatsAppButton />
        </div>
      )}
    </>
  );
};

const mapStateToProps = (state) => ({
  searchReducer: state.searchReducer,
});

const mapDispatchToProps = (dispatch) => ({
  setCity: (payload) => dispatch(serachActions.setCity(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(LandingHome);
